import { action, makeObservable, observable } from "mobx";
import ProgressIndicatorModel, {
  ProgressIndicatorModel as IProgressIndicatorModel
} from "../../../../../../../../components/widgets/ProgressIndicator/ProgressIndicator_model";
import TrainingModulesApi, {
  TrainingModulesApi as ITrainingModulesApi
} from "../../../../../../../../services/api/v2/trainingModules/TrainingModules.api";
import ModalContext from "../../../../../../../modalZ/context/ModalContext";

export class ActionLinkModalModel {
  @observable selectedActionIds: number[] = [];
  @observable isLoading: boolean = true;
  organisationId: number;
  projectId: number;
  trainingModulesProvider: ITrainingModulesApi;
  trainingModule: FP.Entities.ITrainingModule;
  httpProgress: IProgressIndicatorModel;

  /**
   *
   */
  constructor(organisationId: number, projectId: number, trainingModule: FP.Entities.ITrainingModule) {
    makeObservable(this);
    this.organisationId = organisationId;
    this.projectId = projectId;
    this.trainingModulesProvider = TrainingModulesApi;
    this.httpProgress = ProgressIndicatorModel;
    this.trainingModule = trainingModule;
  }

  onMount = async () => {
    await this.getSelectedActions();
    this.setIsLoading(false);
  };

  @action
  setSelectedActions = (selectedActionIds: number[]) => {
    this.selectedActionIds = selectedActionIds;
  };

  @action
  setIsLoading = (isLoading: boolean) => {
    this.isLoading = isLoading;
  };

  getSelectedActions = async () => {
    const res = await this.trainingModulesProvider.getTrainingModuleActionsByTrainingModuleId(
      this.organisationId,
      this.projectId,
      this.trainingModule.id
    );

    if (!res || res.isError) return;

    this.setSelectedActions(res.payload);
  };

  assignActionsToTrainingModules = async (actionIds, onAssignSuccess?: any) => {
    await this.trainingModulesProvider
      .addBulkActionsToTrainingModules(this.organisationId, this.projectId, [this.trainingModule.id], actionIds)
      .then(async e => await onAssignSuccess());

    ModalContext.hide();
  };
}
